
import React, { Component } from 'react';
import Menu from "../Menu";
import Header from '../Header';
import Footer from '../Footer';
import { Navigate } from 'react-router-dom';


class AddDecathlonUser extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: "Add Decathlon Users",
            redirect: null,

        }
    }
    _doNavToVendors = () => {
        this.setState({
            redirect: '/Vendors',
          });
    };

    render() {
        if (this.state.redirect) {
            return (
              <Navigate
                to={{
                  pathname: this.state.redirect,
                }}
              />
            );
          }
        return (
            <div className="wrapper">
                <Header title={this.state.title} />
                <Menu />

                <div className='content-wrapper'>
                    <section className='content top-space'>
                        <div className="m-panel">

                            <div className="m-panel__body">
                                <div className="row m-grid">
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor='exampleInput'>Employee id*</label>
                                            <input type="text" required className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor='exampleInput'>Sur name*</label>
                                            <input type="text" required className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor='exampleInput'>Given name*</label>
                                            <input type="text" required className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor='exampleInput'>Email id*</label>
                                            <input type="email" className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor='exampleInput'>Job title*</label>
                                            <input type="text" required className="form-control" />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group">
                                            <label htmlFor='exampleInput'>Cost centre*</label>
                                            <input type="text" required className="form-control" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-12 text-right">
                                <div className="m-page__button top-space">
                                    <button type='button' onClick={this._doNavToVendors} className='btn muted-button  deca-btn-orange'>Back</button>
                                    <button type='button' className='btn btn-secondary deca-btn-yellow'>Submit</button>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <Footer />
            </div>
        )
    }
}

export default AddDecathlonUser;